import { LogLevel } from '@azure/msal-browser';
import axios from 'axios';

// Get API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://1og6ew7ohl.execute-api.eu-west-1.amazonaws.com/dev';

export const fetchAzureConfig = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/config`);
        return response.data.azure;
    } catch (error) {
        console.error('Failed to fetch Azure AD configuration:', error);
        throw new Error('Unable to load authentication configuration');
    }
};

export const createMsalConfig = (azureConfig) => {
    let redirectUri;
    if (process.env.NODE_ENV === 'development') {
        redirectUri = 'http://localhost:3000';
    } else {
        redirectUri = 'https://snackbar-lookup.redrocket-apps.energy'
    }

    return {
        auth: {
            clientId: azureConfig.clientId,
            authority: azureConfig.authority,
            redirectUri: redirectUri,
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false, 
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                }
            }
        }
    };
};

export const loginRequest = {
    scopes: ["User.Read"]
};


export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};